import { defineStore } from "pinia";
import apiClient from "@/core/buildRequest";

export const useAnnouncementStore = defineStore("announcements", {
  state: () => ({
    publishedAnnouncements: [],
    showModal: false,
    hasFetched: false,
  }),
  actions: {
    async fetchPublishedAnnouncements() {
      try {
        const response = await apiClient.get("announcements", {
          params: { status: "published", per_page: 5 },
        });
        if (response.data?.key === "success") {
          this.publishedAnnouncements = response.data.data.data;
          this.hasFetched = true;

          // Auto-show logic: Only if not already shown in this session
          const sessionShown = sessionStorage.getItem("announce_session_shown");
          if (!sessionShown && this.publishedAnnouncements.length > 0) {
            this.showModal = true;
            // We mark it as shown for the session so it doesn't pop up on every page navigation
            sessionStorage.setItem("announce_session_shown", "1");

            // Still update the last seen ID for reference (e.g. for the badge)
            const latestId = String(this.publishedAnnouncements[0].id);
            localStorage.setItem("last_seen_announcement_id", latestId);
          }
        }
      } catch (error) {
        console.error("Error fetching announcements:", error);
      }
    },
    toggleModal(value) {
      this.showModal = value;
    },
    openModal() {
      this.showModal = true;
    },
    closeModal() {
      this.showModal = false;
    },
  },
});
